import { AlertProps } from "./AlertProps";
import classes from "./Alert.module.scss";
import { clsx } from "clsx";
import { CheckCircle } from "@/components/ui/Icon/CheckCircle";
import { ExclamationCircle } from "@/components/ui/Icon/ExclamationCircle";
import { InfoCircle } from "@/components/ui//Icon/InfoCircle";

const icons = {
  success: CheckCircle,
  error: ExclamationCircle,
  info: InfoCircle,
};

export function Alert(props: AlertProps) {
  const { children, variant = "info", className } = props;

  const classNames = clsx(
    classes.alert,
    {
      [classes.success]: variant === "success",
      [classes.error]: variant === "error",
      [classes.info]: variant === "info",
    },
    className,
  );

  const Icon = icons[variant];

  return (
    <div className={classNames} role="alert">
      <div className={classes.icon}>
        <Icon size={32} color="currentColor" />
      </div>

      <div className={classes.content}>{children}</div>
    </div>
  );
}
